<template>
  <header class="top-header">
    <a-row type="flex" justify="center" style="height: inherit">
      <template v-if="extranetSocketConfig && extranetSocketConfig.diagnosising">
        <a-col :span="5" class="each-item devide-r" style="white-space: nowrap;">
          <img
            :src="extranetStatusPic[extranetSocketConfig.diagnosising].img"
            height="32"
            width="32"
            alt=""
          />
          <label :style="{ color: extranetStatusPic[extranetSocketConfig.diagnosising].textColor }">
            {{ extranetStatusPic[extranetSocketConfig.diagnosising].name }}
          </label>
        </a-col>
        <a-col :span="6" class="each-item">
          <label>{{ $t('page_docdirectory_name') }}：{{ extranetSocketConfig.name }}</label>
        </a-col>
        <a-col :span="3" class="each-item">
          <label>{{ $t('page_my_document_edition') }}：{{ extranetSocketConfig.version }}</label>
        </a-col>
        <a-col :span="6" class="each-item">
          <label
            >{{ $t('page_extranet_Internet_server_address') }}：{{
              extranetSocketConfig.extranetServerAddress
            }}</label
          >
        </a-col>
        <a-col :span="4" class="each-item" style="justify-content: flex-end">
          <connection-record></connection-record>
          <a-dropdown :placement="'bottomRight'" :trigger="['click']">
            <a-button style="margin-right: 16px;">{{
              $t('page_extranet_Diagnostic_log')
            }}</a-button>
            <a-card
              slot="overlay"
              style="width: 590px;margin-top: 14px;box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);"
            >
              <div style="margin: 8px">
                <a-button type="defualt" @click.stop="clearExtranetLogs()">
                  {{ $t('page_extranet_Clear_log') }}
                </a-button>
                <a-input-search
                  v-model="logstr"
                  :placeholder="$t('keyword')"
                  :enter-button="$t('search')"
                  style="width: 48%;float: right;"
                  @search="searchLogs()"
                  @click.stop.native=""
                />
              </div>
              <a-table
                size="middle"
                :columns="logColumns"
                :pagination="false"
                :data-source="filterExtranetLogList"
                style="margin: 8px"
              >
                <div slot="event" slot-scope="event" class="ellipsis" style="width: 150px">
                  <a-tooltip :title="event" placement="top">
                    {{ event }}
                  </a-tooltip>
                </div>
                <div slot="message" slot-scope="message" class="ellipsis" style="width: 225px">
                  <a-tooltip :title="message" placement="top">
                    {{ message }}
                  </a-tooltip>
                </div>
                <div slot="time" slot-scope="time" class="ellipsis" style="width: 150px">
                  <a-tooltip :title="time" placement="top">
                    {{ time }}
                  </a-tooltip>
                </div>
              </a-table>
            </a-card>
          </a-dropdown>
        </a-col>
      </template>
      <template v-else>
        <a-col :span="24" class="each-item">
          <img
            :src="require('@/assets/images/extranetStatus/info-circle.png')"
            height="36"
            width="36"
            alt=""
          />
          <label style="margin-left: 10px;">{{
            $t('page_extranet_Diagnostic_service_is_not_enabled')
          }}</label>
        </a-col>
      </template>
    </a-row>
  </header>
</template>

<script>
import * as _ from 'lodash'
import dayjs from 'dayjs'
import ConnectionRecord from './ConnectionRecord.vue'
import { logColumns, extranetStatusPic } from '../data'

export default {
  name: 'ExtranetHeader',
  components: {
    ConnectionRecord
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          name: '',
          version: '',
          extranetServerAddress: '',
          diagnosising: '',
          code: ''
        }
      }
    },
    logs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      logColumns,
      extranetStatusPic, // 诊断状态图
      logstr: '', // 诊断日志列表搜索字段
      extranetLogList: [], // 连接日志
      filterExtranetLogList: [], // 过滤日志
      extranetSocketConfig: null
    }
  },
  watch: {
    data: {
      handler(data) {
        this.extranetSocketConfig = data
      },
      immediate: true
    },
    logs: {
      handler(data) {
        if (data) {
          this.extranetLogList = _.cloneDeep(data)
          this.extranetLogList.map((item, index) => {
            item.key = index
            item.time = dayjs(item.time).format('YYYY-MM-DD HH:mm:ss')
          })
          this.filterExtranetLogList = _.cloneDeep(this.extranetLogList)
        }
      },
      immediate: true
    }
  },
  methods: {
    // 清空诊断日志
    clearExtranetLogs() {
      this.extranetLogList = []
      this.filterExtranetLogList = []
      this.$emit('clearLogs')
    },
    // 搜索日志
    searchLogs() {
      if (this.logstr) {
        if (this.extranetLogList.length) {
          // console.log('日志列表：', this.extranetLogList)
          this.filterExtranetLogList = this.extranetLogList.filter(
            (item) => item.event.indexOf(this.logstr) > -1 || item.message.indexOf(this.logstr) > -1
          )
        } else {
          this.filterExtranetLogList = []
        }
      } else {
        this.filterExtranetLogList = _.cloneDeep(this.extranetLogList)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../index';
</style>
